import React from 'react';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick?: () => void;
    /** Link href for client-side navigation (e.g. React Router Link). When set, action is rendered as a link. */
    to?: string;
  };
}

const linkClass = 'text-xs uppercase font-bold tracking-widest text-stone-900 underline underline-offset-4 hover:text-stone-700 transition-colors inline-block';

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => (
  <div className="py-20 text-center space-y-6" role="status">
    {icon && <div className="text-5xl grayscale opacity-50" aria-hidden="true">{icon}</div>}
    <h3 className="text-lg font-bold serif text-stone-900">{title}</h3>
    {description && (
      <p className="text-stone-400 font-bold uppercase tracking-widest text-[10px] max-w-sm mx-auto">
        {description}
      </p>
    )}
    {action && action.to !== undefined ? (
      <a href={action.to} className={linkClass}>
        {action.label}
      </a>
    ) : action?.onClick ? (
      <button
        type="button"
        onClick={action.onClick}
        className={linkClass}
      >
        {action.label}
      </button>
    ) : null}
  </div>
);

export default EmptyState;
